import { Languages } from './types';

// Default locale for non-CIS regions (will be overridden by smart detection)
export const DEFAULT_LOCALE = Languages.en;

// LocalStorage keys for language preferences
export const LS_APP_LOCALE_KEY = 'app_locale'; // User's preferred language
export const LS_FORCE_LOCALE_KEY = 'force_locale'; // Temporary language override

// All supported languages in the wrapper
export const SUPPORTED_LOCALES = Object.values(Languages);

// Market source identifiers
export const EXCLUSIVE_MARKET_SOURCE = 'from_exclusive_market';
export const LIGHT_MARKET_SOURCE = 'from_market_light';
export const MARKET_SOURCE = 'from_market';
